// extracted by extract-css-chunks-webpack-plugin
module.exports = {"createAccountWrapper":"ZOKkP","createAccountTitle":"ohxKW","createPassword":"DjIF6","pwdExpressChkOut":"OHP40","phoneNumberNewStyle":"HDD-n","coIconTooltip":"q3bU7"};